import React, { useState } from "react";

import { Button, Flex, Checkbox, Icon } from "../../ppui";

import {
  ColumnAction,
  ColumnHeader,
  ColumnList,
  ColumnManageBg,
  ColumnManageBox,
  ColumnManagement,
  ColumnSelected,
} from "./table-style";
import { TbArrowsMoveVertical , TbLock} from "react-icons/tb";

const ColumnVisibility = ({
  headers,
  visibleColumns,
  // handleSelectAllChange,
  onApply,
}) => {
  const [tempVisibleColumns, setTempVisibleColumns] = useState(visibleColumns);
  const [isVisible, setIsVisible] = useState(false); // State to manage visibility of the column settings

  const handleTempCheckboxChange = (key) => {
    setTempVisibleColumns((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleApply = () => {
    onApply(tempVisibleColumns);
    setIsVisible(false); // Hide the column settings after applying changes
  };

  // Function to get the list of selected columns
  const getSelectedColumns = () => {
    return headers.filter((header) => tempVisibleColumns[header.key]);
  };

  return (
    <>
      <Button variant="outlined" onClick={() => setIsVisible(!isVisible)}>
        Column
      </Button>
      {isVisible && (
        <ColumnManagement>
          <ColumnManageBg />
          <ColumnManageBox>
            <Flex>
              <ColumnList>
                <ColumnHeader>Column Management</ColumnHeader>
                <ul>
                  {/* <li>
                    <Checkbox
                      label="Select All"
                      size="sm"
                      fullWidth
                      checked={Object.values(tempVisibleColumns).every(Boolean)}
                      onChange={handleSelectAllChange}
                    />
                  </li> */}
                  {headers.map((header) => (
                    <li key={header.key}>
                      <Checkbox
                        label={header.label}
                        fullWidth
                        size="sm"
                        checked={tempVisibleColumns[header.key]}
                        onChange={() => handleTempCheckboxChange(header.key)}
                        disabled={header.isVisible} // Change to true if needed
                      />
                    </li>
                  ))}
                </ul>
              </ColumnList>
              <ColumnSelected>
                <ColumnHeader>Column Management</ColumnHeader>
                <ul>
                  {getSelectedColumns().map((header) => (
                    <li key={header.key}>
                      <Icon size={"lg"}> 
                      {header.isVisible ? <TbLock/> : <TbArrowsMoveVertical />}
                      </Icon>
                      {header.label}
                    </li>
                  ))}
                </ul>
              </ColumnSelected>
            </Flex>
            <ColumnAction>
              <Button variant="outlined" onClick={() => setIsVisible(false)}>
                Cancel
              </Button>
              <Button variant="contained" color="primary" onClick={handleApply}>
                Apply
              </Button>
            </ColumnAction>
          </ColumnManageBox>
        </ColumnManagement>
      )}
    </>
  );
};

export default ColumnVisibility;
